export const getCssCustomProperty = (name: string) => {
    if (!document || !document.body || !getComputedStyle) {
        return '';
    }
    const property = getComputedStyle(document.body).getPropertyValue(name);
    if (!property) {
        return '';
    }
    return property.trimStart();
};
